import React from 'react';
import './SearchBar.css';
import searchIcon from '../assets/icons/search.svg';
import angleRightIcon from '../assets/icons/angle-right.svg';

const SearchBar = ({ 
  searchQuery, 
  onSearch, 
  selectedSection, 
  currentTab, 
  onBackToSections,
  aboutActiveScreen,
  onBackFromAbout
}) => {
  // Определяем, когда показывать кнопку "Назад"
  const shouldShowBackButton = (
    (selectedSection && currentTab === 'home') || 
    (aboutActiveScreen && currentTab === 'about')
  );

  return (
    <div className="search-container">
      <div className="search-wrapper">
        {/* Кнопка "Назад" - показывается когда выбран раздел или активен экран в AboutTab */}
        {shouldShowBackButton && (
          <button 
            className="back-search-btn"
            onClick={() => {
              onSearch('');
              if (currentTab === 'home') {
                onBackToSections();
              } else if (currentTab === 'about') {
                onBackFromAbout();
              }
            }}
            title="Назад"
          >
            <img src={angleRightIcon} alt="Назад" className="back-icon" />
            <span>Назад</span>
          </button>
        )}
        
        {/* Поисковая строка - всегда видна */}
        <div className="search-bar">
          <img src={searchIcon} alt="Поиск" className="search-icon" />
          <input 
            type="text" 
            placeholder="Поиск" 
            value={searchQuery}
            onChange={(e) => onSearch(e.target.value)}
          />
          {searchQuery && (
            <button 
              className="clear-search-btn"
              onClick={() => onSearch('')}
            >
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchBar; 